import { Reducer } from 'redux';

import CATEGORIES_CONSTANTS from "../constants/category-constants";
import { CategoryModel } from './../../models/category-model';
import { CategoryAction } from './../types/category-types';

interface CategoryReducerState {
    categories: CategoryModel[];
    categoryFilter: string[];
}

const initialState: CategoryReducerState = {
    categories: [],
    categoryFilter: []
}

export const categoryReducer: Reducer<CategoryReducerState, CategoryAction> = (state = initialState, action: CategoryAction) => {
    switch(action.type) {
        case CATEGORIES_CONSTANTS.GET_CATEGORIES_BEGIN: 
            return {
                ...state,
                loading: true
            };
        case CATEGORIES_CONSTANTS.GET_CATEGORIES_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
                categories: []
            }
        case CATEGORIES_CONSTANTS.GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                categories: action.data.categories
            }
        case CATEGORIES_CONSTANTS.SAVE_CATEGORY_FILTER: 
            return {
                ...state,
                categoryFilter: action.data
            }
        default:
            return state;
    }
}